import { ArrayUtils } from '@colonist/utils';
import { ClientUserState } from '../ClientUserState.ts';
const SHUFFLE_INIT_TIMEOUT_MS = 2000;
export class ClientShuffleQueueController {
    static get shuffleQueueData() {
        return this._shuffleQueueData;
    }
    static get shufflePlayerData() {
        return this._shufflePlayerData;
    }
    static notifyListeners() {
        for (const changeListener of this.changeListeners){
            changeListener(this._shuffleQueueData, this._shufflePlayerData);
        }
    }
    static updateQueueData(queueData) {
        this._shuffleQueueData = queueData;
        this.notifyListeners();
    }
    static updatePlayerData(playerData) {
        this._shufflePlayerData = playerData;
        this.notifyListeners();
    }
    static registerChangeListener(callback) {
        this.changeListeners.push(callback);
        callback(this._shuffleQueueData, this._shufflePlayerData);
        return ()=>{
            ArrayUtils.removeElementFromArray(this.changeListeners, callback);
        };
    }
    static waitForShuffleQueueData() {
        var _ClientUserState_userState;
        if (this._shuffleQueueData != undefined && this._shufflePlayerData != undefined) return Promise.resolve(this._shuffleQueueData);
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) return Promise.resolve(this._shuffleQueueData);
        return new Promise((resolve)=>{
            const timeout = setTimeout(()=>{
                unregister();
                resolve(undefined);
            }, SHUFFLE_INIT_TIMEOUT_MS);
            const unregister = this.registerChangeListener((queueData, playerData)=>{
                if (queueData == undefined) return;
                if (playerData == undefined) return;
                clearTimeout(timeout);
                unregister();
                resolve(queueData);
            });
        });
    }
}
ClientShuffleQueueController.changeListeners = [];
